/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class MonitoringService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns void
     * @throws ApiError
     */
    public heartbeat(): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/monitoring/heartbeat',
            errors: {
                500: `Internal-Server-Error`,
            },
        });
    }

}
